import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Mz. Porter Gateway Page
 *
 * Pre-gate paywall screen that serves as gateway to the live stream.
 * Mobile: Responsive fluid card
 * Desktop: Fixed 440px card, centered
 */

const MzPorterGateway = () => {
  const navigate = useNavigate();

  const handleUnlockAccess = () => {
    navigate('/live');
  };

  return (
    <div style={styles.pageWrapper} className="page-wrapper">
      <div style={styles.contentCard} className="content-card">
        {/* Hero Section */}
        <div style={styles.heroSection}>
          <img
            src="/mz-porter-hero.jpeg"
            alt="Billy Porter"
            style={styles.heroImage}
          />
          {/* Top inner shadow */}
          <div style={styles.heroShadowTop} />
          {/* Bottom inner shadow */}
          <div style={styles.heroShadowBottom} />
          {/* Text overlay - sits on top of shadows */}
          <div style={styles.heroOverlay}>
            <h1 style={styles.heroTitle}>Days in the Life of Mz. Porter</h1>
            <p style={styles.heroSubtitle}>28 days. Real life. No edits.</p>
          </div>
        </div>

        {/* Content Block */}
        <div style={styles.contentBlock}>
          {/* Block 1: Intro */}
          <div style={styles.textBlock}>
            <p style={styles.blockText}>For the first time ever,</p>
            <p style={styles.blockText}>Billy is opening the door to his real life.</p>
          </div>

          {/* Block 2: Experience Description */}
          <div style={styles.textBlock}>
            <p style={styles.blockText}>Mornings. Writing. Friends. Rehearsals.</p>
            <p style={styles.blockText}>Decisions. Silence. Celebration.</p>
            <p style={styles.blockText}>The in-between.</p>
          </div>

          {/* Block 3: Scarcity */}
          <div style={styles.textBlock}>
            <p style={styles.blockText}>1,000 seats only.</p>
            <p style={styles.blockText}>Everyone else will hear about it.</p>
          </div>
        </div>

        {/* Pricing & CTA Container */}
        <div style={styles.pricingCtaContainer}>
          {/* Pricing Bar */}
          <div style={styles.pricingBar}>
            <span style={styles.pricingText}>28 days. One chance.</span>
            <span style={styles.priceAmount}>$28</span>
          </div>

          {/* Divider */}
          <div style={styles.divider} />

          {/* CTA Button */}
          <button style={styles.ctaButton} onClick={handleUnlockAccess}>
            UNLOCK ACCESS
          </button>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <span>
            Powered by{' '}
            <a
              href="https://FullAccess.Live"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.footerLink}
            >
              FullAccess.Live
            </a>
            {' '}&bull; All rights reserved &bull;{' '}
            <a href="mailto:support@fullaccess.live" style={styles.footerLink}>
              support@fullaccess.live
            </a>
          </span>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');

        @media (max-width: 767px) {
          .page-wrapper {
            background-color: #FFFFFF !important;
            padding: 0 !important;
          }
          .content-card {
            box-shadow: none !important;
            border-radius: 0 !important;
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 !important;
          }
        }

        @media (orientation: landscape) and (max-height: 500px) {
          .page-wrapper {
            background-color: #FFFFFF !important;
            padding: 0 !important;
          }
          .content-card {
            border-radius: 0 !important;
          }
        }
      `}</style>
    </div>
  );
};

const styles = {
  pageWrapper: {
    minHeight: '100vh',
    backgroundColor: '#F7F7F7',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '20px 0',
    boxSizing: 'border-box',
    fontFamily: "'Poppins', sans-serif"
  },
  contentCard: {
    width: '440px',
    maxWidth: 'calc(100% - 32px)',
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
  },
  heroSection: {
    position: 'relative',
    width: '100%',
    aspectRatio: '16 / 9',
    backgroundColor: '#1a1a1a',
    overflow: 'hidden'
  },
  heroImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center top',
    transform: 'scale(2.1)'
  },
  heroShadowTop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '80px',
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0))',
    pointerEvents: 'none',
    zIndex: 1
  },
  heroShadowBottom: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '80px',
    background: 'linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0))',
    pointerEvents: 'none',
    zIndex: 1
  },
  heroOverlay: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    padding: '40px 20px 20px',
    background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)',
    textAlign: 'left',
    zIndex: 2
  },
  heroTitle: {
    margin: '0 0 8px 0',
    fontSize: 'clamp(20px, 5vw, 24px)',
    fontWeight: '700',
    color: '#FFFFFF',
    lineHeight: '1.2',
    textAlign: 'left'
  },
  heroSubtitle: {
    margin: '0',
    fontSize: 'clamp(14px, 3.5vw, 16px)',
    fontWeight: 'bold',
    color: '#d61d1d',
    textAlign: 'left'
  },
  contentBlock: {
    padding: '24px 20px 20px',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0'
  },
  blockText: {
    margin: '0',
    fontSize: 'clamp(16px, 4vw, 18px)',
    fontWeight: '500',
    color: '#030303',
    lineHeight: '1.6'
  },
  pricingCtaContainer: {
    backgroundColor: '#eceff1',
    margin: '0 20px',
    padding: '0',
    borderRadius: '4px',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)'
  },
  pricingBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 20px'
  },
  pricingText: {
    fontSize: 'clamp(16px, 4vw, 18px)',
    fontWeight: '500',
    color: '#030303'
  },
  priceAmount: {
    fontSize: 'clamp(24px, 6vw, 32px)',
    fontWeight: '700',
    color: '#d61d1d'
  },
  divider: {
    height: '1px',
    backgroundColor: '#ddd',
    margin: '0 20px'
  },
  ctaButton: {
    /* display: 'block', */
    width: 'calc(100% - 40px)',
    margin: '20px',
    padding: '8px 24px',
    backgroundColor: '#d61d1d',
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    minHeight: '40px',
    transition: 'background-color 0.2s ease',
    fontFamily: "'Poppins', sans-serif"
  },
  footer: {
    padding: '16px 20px 20px',
    textAlign: 'center',
    fontSize: '14px',
    color: '#000000',
    borderTop: '1px #e5e7eb solid',
    marginTop: '20px'
  },
  footerLink: {
    color: '#000000',
    textDecoration: 'underline'
  }
};

export default MzPorterGateway;
